<template>
    <div class="page">
      <TipsHbrb ref="child"></TipsHbrb>
      <PageLoading v-if="loading"></PageLoading>
      <div class="mainBox">
        <div class="rankImg">
          <img src="@/assets/images/guess/rank_txt.png" alt="">          
        </div>
        <div class="rankbox">
          <div class="ranknav">
            <div class="onBox" @click="getRankWin()" v-if="rankType==1">              
              <img src="@/assets/images/guess/ranknav_on.png" alt="" class="navBtn on">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank1.png" alt="" class="rankTxt">
            </div>
            <div class="offBox" @click="getRankWin()" v-else>              
              <img src="@/assets/images/guess/ranknav_off.png" alt="" class="navBtn off">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank1.png" alt="" class="rankTxt">
            </div>

            <div class="onBox" @click="getRankAct()" v-if="rankType==2">              
              <img src="@/assets/images/guess/ranknav_on.png" alt="" class="navBtn on">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank2.png" alt="" class="rankTxt">
            </div>
            <div class="offBox" @click="getRankAct()" v-else>              
              <img src="@/assets/images/guess/ranknav_off.png" alt="" class="navBtn off">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank2.png" alt="" class="rankTxt">
            </div>

            <div class="onBox" @click="getRankScore()" v-if="rankType==3">              
              <img src="@/assets/images/guess/ranknav_on.png" alt="" class="navBtn on">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank3.png" alt="" class="rankTxt">
            </div>
            <div class="offBox" @click="getRankScore()" v-else>              
              <img src="@/assets/images/guess/ranknav_off.png" alt="" class="navBtn off">
              <div class="navTopBox"></div>
              <div class="navBottomBox"></div>
              <img src="@/assets/images/guess/rank3.png" alt="" class="rankTxt">
            </div>


            <!-- <div :class="['rank1',(rankType==1)?'on':'off']" @click="getRankWin()">
              <img src="@/assets/images/guess/rank1_on.png" alt="" v-if="rankType==1">
              <img src="@/assets/images/guess/rank1_off.png" alt="" v-else>
            </div>
            <div :class="['rank2',(rankType==2)?'on':'off']" @click="getRankAct()">
              <img src="@/assets/images/guess/rank2_on.png" alt="" v-if="rankType==2">
              <img src="@/assets/images/guess/rank2_off.png" alt="" v-else>
            </div>
            <div :class="['rank3',(rankType==3)?'on':'off']" @click="getRankScore()">
              <img src="@/assets/images/guess/rank3_on.png" alt="" v-if="rankType==3">
              <img src="@/assets/images/guess/rank3_off.png" alt="" v-else>
            </div> -->

          </div>
          <div class="ranklist">
            <div class="listtop">
              <div class="sort">排名</div>
              <div class="title">昵称</div>
              <div class="phone">手机号</div>
              <div class="score">积分</div>
            </div>
            <div class="listcenter">
              <div class="detail" v-for="(item, index) in rankScore" :key="index">
                <div class="sort">{{index+1}}</div>
                <div class="title">{{item.nickname}}</div>
                <div class="phone">{{item.phone}}</div>
                <div class="score" v-if="rankType==1">{{item.pk_win*actInfo.wscore}}</div>
                <div class="score" v-else-if="rankType==2">{{item.pk_times*actInfo.zscore}}</div>
                <div class="score" v-else>{{item.pk_score}}</div>
              </div>      
              <div class="nodata" v-if="rankScore.length<1">
                暂无数据
              </div>        
            </div>
            <div class="listbottom"></div>
          </div>
        </div>
      
      </div>

      <div class="navBox">
        <div class="navTxt" @click="toIndex">
          <div class="icoBox"><img src="@/assets/images/guess/index_off.png" alt=""></div>
          <div class="icoTitle">首页</div>
        </div>
        <div class="navTxt" @click="toRank">
          <div class="icoBox"><img src="@/assets/images/guess/rank_off.png" alt=""></div>
          <div class="icoTitle">排行榜</div>
        </div>
        <div class="navTxt" @click="toMyCenter">
          <div class="icoBox"><img src="@/assets/images/guess/center_off.png" alt=""></div>
          <div class="icoTitle">我的</div>
        </div>
      </div>

    </div>
</template>

<script>
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import {reqRankScore, reqRankAct, reqRankWin} from '@/api/guess.js'
import zonglan from '@/utils/cp-zonglan.js'
import bgimg from '@/assets/images/learn/pbg.jpg';
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import Cookies from 'js-cookie'
export default {
  mixins: [],
  components: {
    TipsHbrb, PageLoading
  },
  props: {},
  data () {
    return {
      bgimg:bgimg,
      bgcolor:'#e4f3fa',
      learnid:0,
      gid:0,
      actInfo:"",
      token:"",
      accountId:'',
      uniqueId:'',
      userid:0,
      list: [],
      currPage:1,
      loading: true,
      finished: false,
      refreshing: false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
      show: false,
      questionInfo:{},
      opid:0,
      answerRight:false,
      answerError:false,
      Mtop:'4vw',
      rankScore:[],
      rankType:2,
    }
  },
  computed: {},
  watch: {},
  created () {
    this.guessid = this.$route.query.guessid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_logo;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.style = this.$store.state.actInfo.style;   
  },
  mounted() {
   this.getRankAct();
  },
  methods: {
    formatPhoneNumber(phone) {
      if (phone && phone.length === 11) {
        phone = "" + phone;
        var ary = phone.split("");
        ary.splice(3,4,"****");
        var phone1=ary.join("");
      }
      return phone1;
    },
    getRankScore(){
      this.rankType = 3;
      this.loading = true;
      reqRankScore({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.rankScore = res.data.list;

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },

    getRankAct(){
      this.rankType = 2;
      this.loading = true;
      reqRankAct({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.rankScore = res.data.list;

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },
    getRankWin(){
      this.rankType = 1;
      this.loading = true;
      reqRankWin({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.rankScore = res.data.list;

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },
   
     toIndex(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      console.log('00');
      
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    toRank(){
      this.$router.push({ path: '/rank',query:this.$route.query })
    },
  },
  
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/rank.scss';
</style>
